$(document).ready(function(){

  $(".generalmessage").prependTo(".header");
  //prepend general message into header
  if ( $("body").hasClass("generalMessageOn") ) {
      $(".generalmessage").prependTo(".header");
  }
  $( ".footerItems1 a" ).removeClass( "button" );

  // footer logo
  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');

  //Signup Input text Reappeare
  var emailInput = $('.searchBoxInput input');
  emailInput.val('Search');
  emailInput.on("click", function () {
  ClearDefaultText(this, 'Search');
  });
  emailInput.on("blur", function () {
  if ($.trim($(this).val()) == '') {
    $(this).val('Search');
  }
  });
});

$(window).load(function(){
  $('body').addClass('pageIsLoaded');
    $( ".footerItems1 a" ).removeClass( "button" );
  //Signup Input text Reappeare
  var emailInput = $('.searchBoxInput input');
  emailInput.val('Search');
  emailInput.on("click", function () {
  ClearDefaultText(this, 'Search');
  });
  emailInput.on("blur", function () {
  if ($.trim($(this).val()) == '') {
  $(this).val('Search');
  }
  });

  if ($(window).width() < 801) {
    $('.countdown-container').insertBefore('.tier-two');
   
  } else {
    $('.countdown-container').insertAfter('.header-bottom');
    
  }
});


$(window).resize(function(){
  $( ".footerItems1 a" ).removeClass( "button" );
  if ($(window).width() < 801) {
    $('.countdown-container').insertBefore('.tier-two');
   
  } else {
    $('.countdown-container').insertAfter('.header-bottom');
    
  }
});